import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { DashboardDisplayService } from "../dashboardDisplay/dashboardDisplay.service";
import { KpiService } from "../kpi/kpi.service";
import { map } from "lodash";
import { filter } from "rxjs/operators";
import { LaunchDarklyService } from "../launchDarkly/launchDarkly.service";

@Component({
  selector: "metric-settings",
  templateUrl: "./metric-settings.component.html",
  styleUrls: ["./metric-settings.component.scss"],
})
export class MetricSettingsComponent implements OnInit {
  // feature flagging for metric editor
  flagSubscription: Subscription;
  showMetricEditor: boolean = false;
  metricSettingsNavItemData: {
    title: string;
    route: string;
    icon: string;
  }[] = [
    {
      title: "visibility settings",
      route: "/metric/settings/visibility",
      icon: "visibility_settings",
    },
  ];

  constructor(
    private kpiService: KpiService,
    private dashboardDisplayService: DashboardDisplayService,
    private route: ActivatedRoute,
    private router: Router,
    private launchDarklyService: LaunchDarklyService
  ) {
    this.initFlags(launchDarklyService);
    this.flagSubscription = launchDarklyService.flagChange.subscribe(() =>
      this.initFlags(launchDarklyService)
    );
  }

  initFlags(launchDarklyService: LaunchDarklyService) {
    this.showMetricEditor = launchDarklyService.getFlag(
      "mosaic-ui-show-metric-editor"
    );
    if (this.showMetricEditor) {
      this.metricSettingsNavItemData.push({
        title: "metric editor",
        route: "/metric/settings/editor",
        icon: "metric_editor",
      });
    }
  }

  ngOnInit() {
    this.mapNavItemData();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.mapNavItemData();
      });
  }

  ngOnDestroy() {
    this.flagSubscription.unsubscribe();
  }

  navItemClicked(item) {
    map(this.metricSettingsNavItemData, (navItem: any) => {
      navItem.selected = navItem["title"] === item["title"];
    });
    this.router.navigate([item.route]);
  }

  mapNavItemData() {
    map(this.metricSettingsNavItemData, (item: any) => {
      if (
        (this.router.url == "/metric/settings/" ||
          this.router.url == "/metric/settings") &&
        item["title"] == "visibility settings"
      ) {
        item.selected = true;
      } else {
        item.selected = this.router.url.includes(item["route"]);
      }
    });
  }
}
